module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_rn-1d4e89debf28d27932beb28c4a177f82.png";